/* lib/api/ttk.js — REST-клиент /api/ttk/* (порт из frontend/src/lib/api/ttk.js, 1:1).
 * Все ответы — {ok,status,data}. Server-authoritative: мутации строк возвращают свежий
 * TTKDetailSerializer после пересчёта calculated_json. */
import { apiFetch } from './client.js';

export const listTTK = (params = {}) => {
  const query = new URLSearchParams();
  if (params.kind) query.set('kind', params.kind);
  if (params.q) query.set('q', params.q);
  if (params.status) query.set('status', params.status);
  if (params.allergen) query.set('allergen', params.allergen);
  if (params.sort) query.set('sort', params.sort);
  const qs = query.toString();
  return apiFetch(`/api/ttk/${qs ? `?${qs}` : ''}`);
};

export const TTK_STATUSES = [
  { slug: 'ready', label: 'Готовые' },
  { slug: 'unbound', label: 'Без привязки' },
  { slug: 'stub', label: 'Черновики' },
];
export const TTK_SORTS = [
  { slug: '-updated', label: 'Сначала свежие' },
  { slug: 'updated', label: 'Сначала старые' },
  { slug: 'title', label: 'По названию (А→Я)' },
  { slug: '-title', label: 'По названию (Я→А)' },
  { slug: '-kcal', label: 'По ккал (больше→меньше)' },
  { slug: 'kcal', label: 'По ккал (меньше→больше)' },
];
export const TTK_KINDS = [
  { slug: 'dish', label: 'Блюда' },
  { slug: 'semiproduct', label: 'Полуфабрикаты' },
];

export const getTTKUsedIn = (id) => apiFetch(`/api/ttk/${id}/used-in/`);
export const getTTK = (id) => apiFetch(`/api/ttk/${id}/`);
export const createTTKFromMessage = (messageId) =>
  apiFetch('/api/ttk/from-message/', { method: 'POST', body: { message_id: messageId } });
export const createEmptyTTK = ({ title, kind, output_g } = {}) => {
  const body = { title, kind };
  if (output_g != null) body.output_g = output_g;
  return apiFetch('/api/ttk/', { method: 'POST', body });
};
export const updateTTK = (id, payload) =>
  apiFetch(`/api/ttk/${id}/`, { method: 'PATCH', body: payload });
export const deleteTTK = (id) => apiFetch(`/api/ttk/${id}/`, { method: 'DELETE' });

// F41 — bulk-операции multi-select реестра.
export const bulkDeleteTTK = (ids) =>
  apiFetch('/api/ttk/bulk-delete/', { method: 'POST', body: { ids } });
export const buildBulkExportUrl = (ids) =>
  '/api/ttk/export-bulk.zip?ids=' + ids.join(',');

export const linkSemiproduct = (parentId, ingredientIndex, semiproductTtkId) =>
  apiFetch(`/api/ttk/${parentId}/link-semiproduct/`, {
    method: 'POST',
    body: { ingredient_index: ingredientIndex, semiproduct_ttk_id: semiproductTtkId },
  });
export const linkRowToCard = (ttkId, rowId, cardId) =>
  apiFetch(`/api/ttk/${ttkId}/rows/${rowId}/link-card/`, { method: 'POST', body: { card_id: cardId } });
export const createTTKFromCard = (cardId, kind = 'dish') =>
  apiFetch('/api/ttk/from-card/', { method: 'POST', body: { card_id: cardId, kind } });

export const buildExportUrl = (id, portions = 1) => {
  const p = Number(portions);
  const q = Number.isFinite(p) && p > 0 && p !== 1 ? `?portions=${p}` : '';
  return `/api/ttk/${id}/export.docx${q}`;
};
export const cloneTTK = (id, title) => {
  const body = title != null ? { title } : {};
  return apiFetch(`/api/ttk/${id}/clone/`, { method: 'POST', body });
};

// CRUD строк рецепта — возвращают свежий TTKDetailSerializer.data.
export const createRow = (ttkId, body) =>
  apiFetch(`/api/ttk/${ttkId}/rows/`, { method: 'POST', body });
export const createRowsBulk = (ttkId, rows) =>
  apiFetch(`/api/ttk/${ttkId}/rows/bulk/`, { method: 'POST', body: { rows } });
export const updateRow = (ttkId, rowId, body) =>
  apiFetch(`/api/ttk/${ttkId}/rows/${rowId}/`, { method: 'PATCH', body });
export const deleteRow = (ttkId, rowId) =>
  apiFetch(`/api/ttk/${ttkId}/rows/${rowId}/`, { method: 'DELETE' });

export const aiFillRowCard = (ttkId, rowId) =>
  apiFetch(`/api/ttk/${ttkId}/rows/${rowId}/ai-fill-card/`, { method: 'POST' });
export const aiFillMissingRows = (ttkId) =>
  apiFetch(`/api/ttk/${ttkId}/rows/ai-fill-missing/`, { method: 'POST' });

// ── F40 W5: фоновая сборка ДЕРЕВА детей (tree-job) ──────────────────────────
// Единственный механизм генерации рецептов после утверждения меню/ТТК.
// Контракт payload: { status:'idle'|'pending'|'running'|'done'|'cancelled'|
//   'failed', active, total, done, failed, cancel_requested, job_id?,
//   root_entity_kind?, root_entity_id?, nodes:[{node_id,parent_id,level,title,
//   status,entity_id,error,order_index}] }
export const getTreeBuildStatus = (jobId) =>
  apiFetch(`/api/ttk/tree/${jobId}/`);
// Статус по корню (restore после refresh: карточка знает только kind+id).
export const getTreeBuildByRoot = (rootKind, rootId) =>
  apiFetch(`/api/ttk/tree/by-root/${rootKind}/${rootId}/`);
// Ручной запуск/достройка дерева для корня (квота-гейт на беке).
export const startTreeBuild = (rootKind, rootId, ctx = {}) =>
  apiFetch('/api/ttk/tree/start/', {
    method: 'POST', body: { root_kind: rootKind, root_id: rootId, ...ctx },
  });
export const cancelTreeBuild = (jobId) =>
  apiFetch(`/api/ttk/tree/${jobId}/cancel/`, { method: 'POST' });
// «Достроить»: failed-узлы → waiting, переспавн исполнителя.
export const resumeTreeBuild = (jobId) =>
  apiFetch(`/api/ttk/tree/${jobId}/resume/`, { method: 'POST' });
